export default __webpack_public_path__ + "static/media/brokerStepIcon3.386151b6.webp";